import { API_ENDPOINT } from './config';

export const urlsFriEdu = {
  // Unified base for listing courses; use with ?scope=...
  eduCourses: `${API_ENDPOINT}/fri-edu/courses`,
  eduPublicCourses: `${API_ENDPOINT}/fri-edu/courses/indexPublic`,
  eduCoursesDetail: (id) => `${API_ENDPOINT}/fri-edu/courses/${id}`,
  eduPublicCoursesDetail: (id) =>
    `${API_ENDPOINT}/fri-edu/courses/showPublic/${id}`,

  eduLecturers: `${API_ENDPOINT}/fri-edu/lecturers`,

  // Course dates endpoints via index + scope
  eduCourseDates: (courseId) =>
    `${API_ENDPOINT}/fri-edu/courses/${courseId}/course-dates`,
  eduCourseDatesList: `${API_ENDPOINT}/fri-edu/course-dates`,

  // Mutations
  eduCourseDateStore: `${API_ENDPOINT}/fri-edu/course-dates`,
  eduCourseDateDetail: (id) => `${API_ENDPOINT}/fri-edu/course-dates/${id}`,
  eduCourseDateCancel: (id) =>
    `${API_ENDPOINT}/fri-edu/course-dates/${id}/cancel`,
  eduCourseDateEnroll: (id) =>
    `${API_ENDPOINT}/fri-edu/course-dates/${id}/enroll`,
  eduCourseDateUnenroll: (dateId, participantId) =>
    `${API_ENDPOINT}/fri-edu/course-dates/${dateId}/unenroll/${participantId}`,

  eduCourseDateParticipants: (id) =>
    `${API_ENDPOINT}/fri-edu/course-dates/${id}/participants`,
  eduCourseDateSendMessage: (id) =>
    `${API_ENDPOINT}/fri-edu/course-dates/${id}/send-message`,
};

export const routesFriEdu = {
  // Public
  eduCourses: '/fri-edu',

  // CMS (left as-is; adjust if needed elsewhere)
  cmsCoursesList: '/cms/fri-edu/courses',
  cmsCoursesCreate: '/cms/fri-edu/courses/create',
  cmsCoursesEdit: '/cms/fri-edu/courses/edit',
  cmsEduDates: '/cms/fri-edu/courses/dates',
  cmsEduDatesCreate: '/cms/fri-edu/courses/dates/create',
  cmsEduDatesPreview: '/cms/fri-edu/courses/dates/preview',
  cmsEduDatesArchive: '/cms/fri-edu/courses/dates/archiv',
  cmsEduDatesArchivePreview: '/cms/fri-edu/courses/dates/archiv/preview',
  cmsEnrolledCoursesList: '/cms/fri-edu/assigned-courses',
  cmsCourseDetail: '/cms/fri-edu/courses/detail',
  cmsEnrolledCoursesListCreate: '/cms/fri-edu/assigned-courses/create',
  cmsEduDateParticipants: '/cms/fri-edu/courses/dates/participants',
  cmsEduMyDates: '/cms/fri-edu/my-dates',
};
